export interface ProfileNotificationInterface {
	newsletter: boolean,
	privacy: boolean,
}

export class ProfileNotificationClass implements ProfileNotificationInterface {
	newsletter = true;
	privacy = false;
}
